import { render, staticRenderFns } from "./borrower-select.vue?vue&type=template&id=17d604b2&scoped=true"
import script from "./borrower-select.vue?vue&type=script&lang=js"
export * from "./borrower-select.vue?vue&type=script&lang=js"
import style0 from "./borrower-select.vue?vue&type=style&index=0&id=17d604b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d604b2",
  null
  
)

export default component.exports